// SPDX-License-Identifier: GPL-3.0-or-later
//
// Parse JSON from a model response that may or may not be wrapped in markdown
// code fences. Then validate against a runtime predicate.

export function stripFences(s: string): string {
  let t = s.trim();
  // ```json\n...\n```  or  ```\n...\n```
  const fence = /^```(?:json|JSON)?\s*\n([\s\S]*?)\n```\s*$/;
  const m = t.match(fence);
  if (m && typeof m[1] === 'string') t = m[1].trim();
  return t;
}

export interface ParseSuccess<T> { ok: true; value: T }
export interface ParseFailure { ok: false; message: string; raw: string }

export function parseJson<T>(
  raw: string,
  guard: (x: unknown) => x is T,
): ParseSuccess<T> | ParseFailure {
  const text = stripFences(raw);
  let value: unknown;
  try {
    value = JSON.parse(text);
  } catch (err) {
    return {
      ok: false,
      message: `Model output is not valid JSON: ${err instanceof Error ? err.message : String(err)}`,
      raw: text,
    };
  }
  if (!guard(value)) {
    return {
      ok: false,
      message: 'Model output did not match the expected schema.',
      raw: text,
    };
  }
  return { ok: true, value };
}
